export const GET_MERCHANT_COUNT = "GET_MERCHANT_COUNT"
export const GET_MERCHANT_COUNT_ERR = "GET_MERCHANT_COUNT_ERR"
